import * as React from "react";
import { NavLink, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

import styled from "styled-components";

import OrganisationDirectoryResults from "./OrganisationDirectoryResults";
import OrganisationDirectorySearchForm from "./OrganisationDirectorySearchForm";
import { Analytics } from "@skv/core";

const ALPHABET = "abcdefghijklmnopqrstuvwxyz";

const Glyph = styled.span``;

const OrgNavLink = styled(NavLink).attrs((props) => ({
  isActive: (match, location) => {
    // console.log(match, location);
    const arr = location.pathname.split("/");
    return arr[arr.length - 1] === props.to;
  },
}))`
  font-size: ${18 / 16}rem;
  display: block;
  padding: 0.25rem ${10 / 16}rem;
  font-weight: bold;

  &:hover {
    text-decoration: none;
  }

  &:hover,
  &.active {
    ${Glyph} {
      border-bottom: 2px solid ${(p) => p.theme.darkColor};
    }
  }
`;

const ListInlineItem = styled.li`
  display: inline-block;
`;

const OrganisationDirectory = () => {
  const params = useParams<{ letter: string }>();
  const letter = String(params.letter).toLowerCase();

  return (
    <>
      <Helmet>
        {letter === "0" ? (
          <title>{`List of registered organisations starting with a number`}</title>
        ) : (
          <title>{`List of registered organisations starting with ${letter.toUpperCase()}`}</title>
        )}
      </Helmet>
      <Analytics
        data={{
          subSection: "organisation",
          subSubSection: "organisation:directory",
          subSubSubSection: "organisation:directory",
          pageTitle: "organisation:directory",
          pageType: "organisation:directory",
        }}
      />
      <section>
        <header className="pt-5 pb-3 bg-light">
          <div className="container">
            <h1>Organisation directory</h1>

            <nav>
              <ul className="list-inline">
                {ALPHABET.toUpperCase()
                  .split("")
                  .map((letter, idx) => (
                    <ListInlineItem key={idx}>
                      <OrgNavLink
                        className="text-dark"
                        to={letter.toLowerCase()}
                      >
                        <Glyph>{letter}</Glyph>
                      </OrgNavLink>
                    </ListInlineItem>
                  ))}
                <ListInlineItem>
                  <OrgNavLink className="text-dark" to="0">
                    <Glyph>0-9</Glyph>
                  </OrgNavLink>
                </ListInlineItem>
              </ul>
            </nav>
          </div>
        </header>

        <div className="py-4">
          <h2 className="mb-4">
            <span className="sr-only">
              Showing organisations that start with the letter
            </span>
            {letter === "0" ? "0 - 9" : letter.toUpperCase()}
          </h2>

          <OrganisationDirectoryResults letter={letter} />
        </div>

        <div className="bg-light py-4">
          <div className="container">
            <OrganisationDirectorySearchForm />
          </div>
        </div>
      </section>
    </>
  );
};

export default OrganisationDirectory;
